import type { IChatListObject, ISelectPinnedChatsProps } from "../types/chat";
import { dedupeChatsByUuid } from "./dedupe-chat-list";

const getPinnedAtTime = (chat: IChatListObject): number => {
  if (!chat.pinnedAt) return 0;

  const pinnedAtTime = new Date(chat.pinnedAt).getTime();

  return Number.isNaN(pinnedAtTime) ? 0 : pinnedAtTime;
};

// NOTE: NSAI-5678 — the sidebar's Pinned section is fed by two lists now (the
// regular and the assistant one), so the "root-level pinned chats, most recently
// pinned first" selection both apps used to inline lives here. A chat without a
// pinnedAt sorts last rather than freezing the comparator at 0, which left the
// order to whatever the server sent.
//
// NOTE: NSAI-5678 (review follow-up) — deduped by uuid, because the caller
// passes both lists' chats concatenated and a server that doesn't know `kind`
// (old backend, new frontend mid-rollout) answers both the regular and the
// assistant request with the user's whole history: every pinned chat would
// then be a duplicate of itself across the two arrays and render twice.
// dedupeChatsByUuid keeps the first occurrence, same as the two lists already
// do internally for the offset-pagination hazard it was built for.
export const selectPinnedChats = ({
  chats,
}: ISelectPinnedChatsProps): IChatListObject[] =>
  dedupeChatsByUuid({
    chats: chats.filter((chat) => chat.isPinned && !chat.folderId),
  }).sort((chatA, chatB) => getPinnedAtTime(chatB) - getPinnedAtTime(chatA));
